export default function createClientAction(context, payload, done) {
    context.dispatch('USER_CLIENTS_ADDED', payload);
    done();
}
